<div class="c__rotation-wrapper" [ngStyle]="customStyle">
  @if (!clicked && !play) {
    <div class="c__rotation-legend"
      >
      <span sd-button
        [isIcon]="true"
        icon="icon-arrow-double"
        [tabIndex]="-1"
        aria-hidden="true">
      </span>
      <div class="c__legend-guidelines"></div>
    </div>
  }

  <canvas width="100%" height="100%"
    #canvasElement
    aria-hidden="true"
    class="c__rotation-canvas {{ clicked ? 'is-clicked' : ''}}"
    (mousedown)="mousedown()"
    (mouseleave)="mouseup()"
    (mouseup)="mouseup()">
  </canvas>

  <button sd-button
    class="c__toggle"
    type="button"
    (click)="togglePlay()"
    [isIcon]="true"
    [isSmall]="true"
    [icon]="play ? 'icon-pause' : 'icon-play'">
    <span class="is-visually-hidden">
      {{ (play ? 'actions.stop' : 'actions.start') | translate }} - {{ context }}
    </span>
  </button>
</div>
